import { call, put, takeLatest } from 'redux-saga/effects';
import { AnswerTypes } from 'services/api';
import {
  deleteAnswerType,
  deleteAnswerTypeSuccess,
  deleteAnswerTypeFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* deleteAnswerTypeSaga(action) {
  try {
    const data = yield call(AnswerTypes.deleteAnswerType, action.payload);
    yield put(deleteAnswerTypeSuccess(data));
    yield put(
      notificationActions.addNotification([
        {
          type: 'success',
          message: { code: 'deleted', resource: 'answerType' },
        },
      ])
    );
  } catch (e) {
    yield put(deleteAnswerTypeFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(deleteAnswerType, deleteAnswerTypeSaga);
